import React, { useState } from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  Icon,
  Input,
  Text, useStyleConfig,
} from '@chakra-ui/react';
import {
  fetchMoreSkills,
} from '../utils';
import { ExpertiseStyle } from '../../../styles/partials/elements/ExpertiseStyle';
import { RiArrowDropRightFill } from 'react-icons/ri';
import { RiArrowDropDownFill } from 'react-icons/ri';
import {  RiSearchLine } from 'react-icons/ri';

const AdvancedSearchBox = ({ props, qObj }) => {
  const resumeIndex = props.stateProps.sectionData.resumeIndex;
  const resume = props.stateProps.dataToSave.saved.resumes[resumeIndex];
  let industry = resume.industry[0];
  industry = industry.charAt(0).toUpperCase() + industry.slice(1);
  const jobTitle = resume.job_title;
  const style = ExpertiseStyle.variants.wrapper;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <Box sx={{ ...style.mainBox }}>
      <HStack>
        <Text sx={{ ...style.advancedSearchText }}>Advanced Search</Text>
        <Button sx={{...buttonStyles.expertiseSearch}} onClick={() => toggle(!isOpen)}>
          {isOpen ? (
            <Icon as={RiArrowDropDownFill} boxSize={8} />
          ) : (
            <Icon as={RiArrowDropRightFill} boxSize={8} />
          )}
        </Button>
      </HStack>
      <>
      {isOpen && (
        <Flex sx={{ flexWrap: 'wrap' }} marginBottom='.5rem'>
          <Box marginRight='1rem' marginLeft='.5rem'>
          <Input sx={{ ...style.inputGroup.inputField }}
                 backgroundColor={'WHITE'}
                 margin="0rem !important"
                 id="expertiseKeywordSearch"
                 placeholder="Keyword"
          />
          </Box>
          <Box marginRight='1rem'>
            <Input sx={{ ...style.inputGroup.inputField }}
                   borderColor="GRAY_2"
                   backgroundColor={'WHITE'}
                   id="expertiseJobTitleSearch"
                   defaultValue={jobTitle}
            />
          </Box>
          <Box marginRight='1rem'>
            <Input sx={{ ...style.inputGroup.inputField }}
                   borderColor="GRAY_2"
                   backgroundColor={'WHITE'}
                   id="expertiseIndustrySearch"
                   defaultValue={industry}
            />
          </Box>
          <Button
            variant="skillSearch"
            margin="0"
            width="fit-content"
            onClick={() => {
              fetchMoreSkills(props, qObj);
            }}
          >
            <Icon as={RiSearchLine} boxSize={5} />
          </Button>
        </Flex>
      )}
      </>

    </Box>
  );
};
export default AdvancedSearchBox;
/**
 * import React, { useState } from 'react';
 * import {
 *   Box,
 *   Button,
 *   Flex,
 *   Icon,
 *   Input,
 *   InputGroup, InputLeftAddon, InputRightAddon,
 * } from '@chakra-ui/react';
 * import {
 *   fetchMoreSkills,
 * } from '../utils';
 * import { ExpertiseStyle } from '../../../styles/partials/elements/ExpertiseStyle';
 * import {  RiSearchLine } from 'react-icons/ri';
 *
 * const AdvancedSearchBox = ({ props,qObj }) => {
 *   const resumeIndex = props.stateProps.sectionData.resumeIndex;
 *   const resume = props.stateProps.dataToSave.saved.resumes[resumeIndex];
 *   let industry = resume.industry[0]
 *     industry  = industry.charAt(0).toUpperCase() + industry.slice(1);
 *   const [showButtons,setShowButtons] = useState(false);
 *   const jobTitle = resume.job_title;
 *   const style = ExpertiseStyle.variants.wrapper;
 *
 *   return (
 *     <Box sx={{ ...style.mainBox }}>
 *       <>
 *           <Flex sx={{ flexWrap: 'wrap' }}>
 *             <InputGroup sx={{ ...style.inputGroup }} border='1px solid black' borderRadius='5px'
 *                         height="fit-content">
 *
 *                 <Button
 *                   variant="skillSearch"
 *                   margin="0"
 *                   width='fit-content'
 *                   onClick={() => {
 *                     fetchMoreSkills(props,qObj);
 *                   }}
 *                 >
 *                   <Icon as={RiSearchLine} boxSize={5} />
 *                 </Button>
 *               <Input sx={{ ...style.inputGroup.inputField }}
 *                 backgroundColor={'WHITE'}
 *                      margin='0rem !important'
 *                 id="expertiseKeywordSearch"
 *                 placeholder="Keyword"
 *               />
 *             </InputGroup>
 *             <Button
 *               padding="1.35rem 0 !important"
 *               variant="skillSearch"
 *               onClick={() => {
 *                 setShowButtons(!showButtons)
 *               }}
 *             >
 *               +
 *             </Button>
 *             {showButtons &&
 *               <Box>
 *                 <Input sx={{ ...style.inputGroup.inputField }}
 *                        borderColor="GRAY_2"
 *                        backgroundColor={'WHITE'}
 *                        id="expertiseJobTitleSearch"
 *                        defaultValue={jobTitle}
 *                 />
 *                 <Input sx={{ ...style.inputGroup.inputField }}
 *                        borderColor="GRAY_2"
 *                        backgroundColor={'WHITE'}
 *                        id="expertiseIndustrySearch"
 *                        defaultValue={industry}
 *                 />
 *               </Box>
 *             }
 *           </Flex>
 *       </>
 *
 *     </Box>
 *   );
 * };
 * export default AdvancedSearchBox;
 * /**
 *  *
 *  *
 *  *             <InputGroup sx={{ ...style.inputGroup }}>
 *  *               <Select
 *  *                 id="expertiseIndustrySearch"
 *  *                 borderColor="GRAY_2"
 *  *                 backgroundColor={'WHITE'}
 *  *               >
 *  *                 <option key="none" value="none">
 *  *                   Select an Industry
 *  *                 </option>
 *  *                 {Object.entries(industries).map(industry => {
 *  *                   return formatIndustryOption(industry);
 *  *                 })}
 *  *               </Select>
 *  *             </InputGroup>
 *
 *  */
